module.exports = __webpack_public_path__ + "img/head_portrait.1e9d859e.jpg";